import React from 'react';

function useIsMounted(): boolean {
    const isMounted = React.useRef(true);

    React.useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    return isMounted.current;
}

export default useIsMounted;
